// Centralized Stripe payment links for each seva.
// Keys align with `id` values used in SevaOfferingsSection and DonationFlow route params.

export const paymentLinks = {
  prabhupada: {
    recurring: "https://donate.stripe.com/3cI5kDdep6bx57h0mcf7i07",
    oneTime: "https://donate.stripe.com/3cI6oH4HT1VharBed2f7i0a",
  },
  tulasi: {
    recurring: "https://donate.stripe.com/fZucN55LXdDZbvF5Gwf7i06",
    oneTime: "https://donate.stripe.com/6oUaEX3DPdDZ2Z98SIf7i0c",
  },
  sudarshan: {
    recurring: "https://donate.stripe.com/9B65kDb6harNfLV2ukf7i05",
    oneTime: "https://donate.stripe.com/7sYcN58Y943p1V59WMf7i0d",
  },
  nrsimha: {
    recurring: "https://donate.stripe.com/00wbJ16Q143pczJ3yof7i00",
    oneTime: "https://donate.stripe.com/8x28wPeit6bx0R1glaf7i0g",
  },
  gauranitai: {
    recurring: "https://donate.stripe.com/bJe00jb6h0Rd2Z94Csf7i04",
    oneTime: "https://donate.stripe.com/4gM28r7U5bvR9nxed2f7i0e",
  },
  jbs: {
    recurring: "https://donate.stripe.com/00w28r8Y92Zl2Z95Gwf7i03",
    oneTime: "https://donate.stripe.com/7sY00j5LX0RdeHR0mcf7i0f",
  },
  radhakrishna: {
    recurring: "https://donate.stripe.com/eVq28rfmx57t57h6KAf7i02",
    oneTime: "https://donate.stripe.com/7sY00jcalczVgPZ2ukf7i0h",
  },
  radhagopi: {
    recurring: "https://donate.stripe.com/14AaEX3DP1VhczJfh6f7i01",
    oneTime: "https://donate.stripe.com/7sY8wP5LX43pdDN9WMf7i0b",
  },
};
